// @ts-strict-ignore
import React from 'react'
import { startCase } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { CopyButton, Box as Row } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { SidePanelHeaderTemplateTwo } from 'components/SidePanel/SidePanelHeaderTemplates/SidePanelHeaderTemplateTwo'
import { useTransactionIcons } from 'pages/Wallets/hooks/useTransactionIcons'
import { TransactionType } from 'types/transaction/TransactionType'
import { useTransactionHistoryLabel } from './hooks/useTransactionHistoryLabel'

interface SidePanelHeaderTransactionHistoryProps {
  data: {
    iconUrls: string[]
    amountWithCurrency: string
    transactionType: string
    transactionSubType: string
    customerReference: string
    transformedData: { fromAmount: string }
    name?: string
  }
}

export const SidePanelHeaderTransactionHistory = ({
  data,
}: SidePanelHeaderTransactionHistoryProps) => {
  const { t } = useTranslation()
  const {
    iconUrls,
    amountWithCurrency,
    transactionType,
    transactionSubType,
    customerReference,
    transformedData,
    name,
  } = data

  const transactionsTypeSubType = `${transactionType}_${transactionSubType}`
  const { singleIcon, isMultipleIcons } = useTransactionIcons(transactionsTypeSubType, iconUrls)

  const secondaryLabelContent = useTransactionHistoryLabel({
    transactionType,
    transactionSubType,
    name,
    fallback: startCase(transactionType).replace('Fdusd', 'FDUSD'),
  })

  return (
    <SidePanelHeaderTemplateTwo
      heading={{
        iconUrls: isMultipleIcons ? iconUrls : singleIcon,
        primaryLabel:
          transactionType === TransactionType.LATE_PAYMENT
            ? transformedData?.fromAmount
            : amountWithCurrency,
        secondaryLabel: secondaryLabelContent,
      }}
      {...(!!customerReference && {
        reference: {
          legend: customerReference && t('customerReference'),
          label: !!customerReference && (
            <Row flex className="items-center">
              <span className="text-body-regular text-foreground-prominent">
                {ellipseMiddleText(customerReference, 10, 10)}
              </span>
              <CopyButton copyText={customerReference} />
            </Row>
          ),
        },
      })}
    />
  )
}
